import { SxProps } from '@mui/material';
import { DataGridProProps } from '@mui/x-data-grid-pro/models/dataGridProProps';
import { useMemo } from 'react';

type PropsType = {
  rowsCount: number;
  settings: {
    scrollRowCount: number;
    rowHeight: number;
    headerRowHeight: number;
  };
};
type UseDataGridAutoHeightToScrollOutput = {
  containerProps: {
    sx?: SxProps;
  };
  dataGridProps: Pick<DataGridProProps, 'autoHeight'>;
};

export const useDataGridAutoHeightToScroll = (
  props: PropsType,
): UseDataGridAutoHeightToScrollOutput => {
  const { rowsCount, settings } = props;

  const { isVerticalScrollEnabled, dataGridContainerSx } = useMemo(() => {
    const { scrollRowCount, rowHeight, headerRowHeight } = settings;

    const isVerticalScrollEnabled = rowsCount > scrollRowCount;
    const dataGridHeight = scrollRowCount * rowHeight + headerRowHeight;

    return {
      isVerticalScrollEnabled,
      dataGridContainerSx: isVerticalScrollEnabled
        ? { height: `${dataGridHeight}px` }
        : undefined,
    };
  }, [rowsCount, settings]);

  return {
    containerProps: {
      sx: dataGridContainerSx,
    },
    dataGridProps: {
      autoHeight: !isVerticalScrollEnabled,
    },
  };
};
